import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { is } from "app/pages/sales-intelligence/utils/type-guards";
import { NoCacheHeaders } from "app/services/fetchService";

import {
    fetchIntentSignalsDataThunk,
    fetchSignalsAndApplyBasedOnParamsThunk,
    fetchSignalsDescriptionThunk,
    fetchSignalsThunk,
} from "../store/effects";
import type { SignalsRoutingParams } from "../types";

export default function useSignalsFetch(): void {
    const dispatch = useDispatch();

    const { params } = useCurrentStateAndParams<Partial<SignalsRoutingParams>>();

    useMount(() => {
        const { signalId, digestType } = params;

        const applySignalsConditions = [!is.undefined(signalId), !is.undefined(digestType)];
        const shouldApplySignals = applySignalsConditions.some(Boolean);

        if (shouldApplySignals) {
            void dispatch(
                fetchSignalsAndApplyBasedOnParamsThunk(params, {
                    headers: NoCacheHeaders,
                }),
            );
        } else {
            void dispatch(fetchSignalsThunk());
        }

        void dispatch(fetchSignalsDescriptionThunk());

        void dispatch(fetchIntentSignalsDataThunk());
    });
}
